module.exports = __webpack_public_path__ + "img/big_snow.36368278.png";